const namespaced = true;
// 数据
let state = {
  nameFromApi: "",
  mobileFromApi: "",
  province: "", // 省
  city: "", // 市
  mobile: "", // 手机号
  code: "", // 验证码
  name: "", // 姓名
  email: "", // 邮箱
  company: "", // 公司名称
  address: "", // 公司地址
  cityname: "", // 公司省市
  post: "", // 职务
  postName: "", // 职务
  postMessage: "", // 职务
  duty: "", // 职责
  dutyName: "", // 职责
  dutyMessage: "", // 职责
  product: [], // 感兴趣的产品
  productID: [], // 感兴趣的产品
  productName: "", // 感兴趣的产品
  productMessage: "", // 感兴趣的产品
  science: [], // 技术领域
  scienceID: [], // 技术领域
  scienceName: "", // 技术领域
  scienceMessage: "", // 技术领域
  qcc_company: "", //企查查公司
  dgk_province: "", // 省(dgk)
  dgk_city: "", // 市(dgk)
  dgk_cityname: "", // 公司省市(dgk)
  dgk_post: "", // 职务(dgk)
  dgk_postName: "", // 职务
  dgk_postMessage: "", // 职务
  dgk_industry: "", // 行业(dgk)
  dgk_industryName: "", // 职务
  dgk_industryMessage: "", // 职务
  source: "",
  is_vip: 2,
  get_api_info: true, // 是否从api获取数据
  encompany: "", // 英文公司名称
};

// 事件
let actions = {
  changeAll({ commit }, data) {
    commit("setAll", data);
  },
  changePost({ commit }, data) {
    commit("setPost", data);
  },
  changeDuty({ commit }, data) {
    commit("setDuty", data);
  },
  changeProduct({ commit }, data) {
    commit("setProduct", data);
  },
  changeScience({ commit }, data) {
    commit("setScience", data);
  },
  changeApiInfo({ commit }, data) {
    commit("setApiInfo", data);
  },
  changeencompany({ commit }, data) {
    commit("setencompany", data);
  },
  changeqcccompany({ commit }, data) {
    commit("setqcccompany", data);
  },

  changeDgkPost({ commit }, data) {
    commit("setDgkPost", data);
  },
  changeDgkIndustry({ commit }, data) {
    commit("setDgkIndustry", data);
  },
};

// 改变
let mutations = {
  setAll(state, data) {
    (state.nameFromApi = data.nameFromApi),
      (state.mobileFromApi = data.mobileFromApi),
      (state.province = data.province), // 省
      (state.city = data.city), // 市
      (state.mobile = data.mobile), // 手机号
      (state.code = data.code), // 验证码
      (state.name = data.name), // 姓名
      (state.email = data.email), // 邮箱
      (state.company = data.company), // 公司名称
      (state.address = data.address), // 公司地址
      (state.cityname = data.cityname), // 公司省市
      (state.post = data.post), // 职务
      (state.postName = data.postName), // 职务
      (state.postMessage = data.postMessage), // 职务
      (state.duty = data.duty), // 职责
      (state.dutyName = data.dutyName), // 职务
      (state.dutyMessage = data.dutyMessage), // 职务
      (state.product = data.product), // 感兴趣的产品
      (state.productID = data.productID), // 感兴趣的产品
      (state.productName = data.productName), // 感兴趣的产品
      (state.productMessage = data.productMessage); // 感兴趣的产品
    (state.science = data.science), // 技术领域
      (state.scienceID = data.scienceID), // 技术领域
      (state.scienceName = data.scienceName); // 技术领域
    state.scienceMessage = data.scienceMessage; // 技术领域
    state.source = data.source;
    state.is_vip = data.is_vip;
    state.encompany = data.encompany;
    state.qcc_company = data.qcc_company;
    // dgk专用字段
    state.dgk_province = data.dgk_province; // 省
    state.dgk_city = data.dgk_city; // 市
    state.dgk_cityname = data.dgk_cityname; // 公司省市
    state.dgk_post = data.dgk_post; // 职务
    state.dgk_postName = data.dgk_postName; // 职务
    state.dgk_postMessage = data.dgk_postMessage; // 职务
    state.dgk_industry = data.dgk_industry; // 行业
    state.dgk_industryName = data.dgk_industryName; // 行业
    state.dgk_industryMessage = data.dgk_industryMessage; // 行业
  },
  setPost(state, data) {
    state.post = data.post;
    state.postName = data.postName;
    state.postMessage = data.postMessage;
  },
  setDuty(state, data) {
    state.duty = data.duty;
    state.dutyName = data.dutyName;
    state.dutyMessage = data.dutyMessage;
  },
  setProduct(state, data) {
    state.product = data.product;
    state.productID = data.productID;
    state.productName = data.productName;
    state.productMessage = data.productMessage;
  },
  setScience(state, data) {
    state.science = data.science;
    state.scienceID = data.scienceID;
    state.scienceName = data.scienceName;
    state.scienceMessage = data.scienceMessage;
  },
  setApiInfo(state, data) {
    state.get_api_info = data;
  },
  setencompany(state, data) {
    state.encompany = data;
  },
  setqcccompany(state, data) {
    state.qcc_company = data;
  },
  setDgkPost(state, data) {
    state.dgk_post = data.dgk_post;
    state.dgk_postName = data.dgk_postName;
    state.dgk_postMessage = data.dgk_postMessage;
  },
  setDgkIndustry(state, data) {
    state.dgk_industry = data.dgk_industry;
    state.dgk_industryName = data.dgk_industryName;
    state.dgk_industryMessage = data.dgk_industryMessage;
  },
};
// 获取
let getters = {};
export default {
  namespaced,
  actions,
  state,
  mutations,
  getters,
};
